import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Subject, Observable } from 'rxjs';
import { takeUntil, withLatestFrom, filter } from 'rxjs/operators';
import * as fromComm from 'src/app/modules/communications/store/communications';
import { ConfiguredChannel } from 'src/app/modules/communications/store/communications/communications.model';
import { cloneDeep } from 'lodash-es';
import { GUID_EMPTY, API_BASE_URL as apiBaseUrl } from '@app/core/constants';

@Component({
  selector: 'topo-sendgrid-email-edit',
  templateUrl: './sendgrid-email-edit.component.html',
  styleUrls: ['./sendgrid-email-edit.component.scss'],
  standalone: false
})
export class SendGridEmailEditComponent implements OnInit, OnDestroy {
  @Input() isActive: boolean;
  configuredChannel: ConfiguredChannel;
  destroy$ = new Subject<void>();
  emptyGuid = GUID_EMPTY;
  webhookUrl: string;

  constructor(
    private store: Store<fromComm.State>,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.store
      .select(fromComm.selectSendGridEmailEditIsActive)
      .pipe(takeUntil(this.destroy$))
      .subscribe(isActive => (this.isActive = isActive));

    this.store
      .select(fromComm.selectSelectedConfiguredChannel)
      .pipe(
        withLatestFrom(this.store.select(fromComm.selectSendGridEmailEditIsActive)),
        filter(([, isActive]) => isActive),
        takeUntil(this.destroy$)
      )
      .subscribe(([selectedChannel, isActive]) => {
        this.configuredChannel = !!selectedChannel ? cloneDeep(selectedChannel) : null;
        this.webhookUrl = `${apiBaseUrl}/v1/notifications/sendgrid/status-webhook`;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  close(): void {
    this.store.dispatch(fromComm.closeConfiguredChannelEdit());
  }

  cancelClick(): void {
    this.close();
  }

  saveClick(): void {
    this.store.dispatch(fromComm.saveConfiguredChannelToApi({ channel: this.configuredChannel }));
  }
}
